import {
  Box,
  Spinner,
  Step,
  StepIndicator,
  StepStatus,
  Stepper,
  useDisclosure,
  Image,
  StepSeparator,
  Button,
  Tooltip
} from '@chakra-ui/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import React from 'react';
import { reinitiateTransfer } from '@/api/apis.js';
import Transfer from '../../model/transfer.mjs';
import {
  formatPhoneNumber,
  getEightDigitLicenseKey,
  getFormattedProduct
} from '@/explore/ffl-detail/utils.mjs';
import FFLDetailModal from '@/explore/ffl-detail/FFLDetailModal';
import {
  callToEZCheckForTransferCreation,
  setEZCheckStatusTransferCreation,
  setIsTransferReinitiateAllowed,
  setTransferStatusWorkflow,
  setTransferSuggestion,
  setisTransferCreationAllowed,
  setIsRefreshingTransferStatus,
  callToUpdateTransferArchive,
  setIsTransferForArchiveUpdated,
  setTransferCurrentNavigation,
  setInboundTransferStatusWorkflow,
  callInBoundTransferAction,
} from '../ducks/slice';
import { useDispatch } from 'react-redux';
import { setIsEzCheckHistoryInprogress } from '@/explore/ducks/slice';
import {
  getIsEZCheckForTransferCreationInProgress,
  getIsFetchingTransferStatusWorkflow,
  getIsTransferReinitiateAllowed,
  getTransferStatusWorkflow,
  getTransferSuggestion,
  getezCheckStatusTransferCreation,
  getIsRefreshingTransferStatus,
  getIsUpdatingTransferForArchive,
  getIsTransferForArchiveUpdated,
  getTransferCurrentNavigation,
  getInboundTransferStatusWorkflow,
} from '../ducks/selectors';
import { Key } from 'react-aria-components';
import {
  Toastertype,
  TransferCurrentNavigation,
  TransferDetailsType,
  TransferMacrostatus,
  TransferMicroStatusWorkflow,
  TransferStatusWorkflow,
  keyType
} from '../types';
import {
  ARCHIVED,
  ARCHIVE_TEXT,
  BUSINESS_NAME,
  DOWNLOAD_MASTER_PROOF_TEXT,
  INBOUND_TRANSFER_ACTION,
  INBOUND_TRANSFER_API_STATUES_RESPONSE,
  INBOUND_TRANSFER_STATUS_CORRESPONDING_ACTION,
  TRANSFER_ACTION_SUCCESSFULL,
  TRANSFER_DETAILS,
  TRANSFER_QUEUE,
  UN_ARCHIVED,
  UN_ARCHIVE_TEXT,
  VIEW_THE_PAGE,
  inboundTransferMacroStatus,
  transferStepStatus,
  transferTips
} from '@/utils/constants';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import { useSearchParams } from 'react-router-dom';
import TransferStatusStepper from './TransferStatusStepper';
import { getIsGlobalAdmin } from '@/redux/app-selectors';

const optoutValues = ['order', 'store', 'all'];
const optinValues = {
  opt_in_all: 'all',
  opt_in_store: 'store',
  opt_in_order: 'order'
};

let transferStatusInterval: NodeJS.Timeout | undefined;
const TRANSFER_STATUS_INTERVAL_TIME = 2000;

export default function TransferDetail({
  data,
  cognitoGroup,
  isSuperAdmin,
  isStoreAdmin,
  transferStatus,
  transferDetails,
  isFetchingDetails,
  onchangeStatusDropdown,
  getTransferStatus,
  refreshTransferDetails,
  handleClose,
  refetchTranferQueue,
}: {
  data: {id: string} | null;
  isSuperAdmin: boolean;
  cognitoGroup: boolean;
  transferStatus: string;
  isStoreAdmin: boolean;
  isFetchingDetails: boolean;
  transferDetails: TransferDetailsType;
  onchangeStatusDropdown(arg: Key): void;
  getTransferStatus(): void;
  refreshTransferDetails(): void;
  handleClose(): void;
  refetchTranferQueue(): void;
}) {
  const [licenseeId, setLicenseeId] = useState<string>('');
  const [isReinitiating, setIsReinitiating] = useState(false);
  const [hideRefreshBtn, setHideRefreshBtn] = useState(true);
  const [searchParams, setURLSearchParams] = useSearchParams();
  const [isDownloadTransferProofEnabled, setisDownloadTransferProofEnabled] =
    useState(false);
  const dispatch = useDispatch();

  const isTransferReinitiateAllowed = getIsTransferReinitiateAllowed();
  const ezCheckStatus = getezCheckStatusTransferCreation();
  const ezCheckForTransferCreationInProgress =
    getIsEZCheckForTransferCreationInProgress();
  const isRefreshingTransferStatus = getIsRefreshingTransferStatus();
  const isUpdatingTransferForArchive = getIsUpdatingTransferForArchive();
  const isTransferForArchiveUpdated = getIsTransferForArchiveUpdated();
  const transferCurrentNavigation = getTransferCurrentNavigation();

  async function onClickReinitiate() {
    dispatch(
      callToEZCheckForTransferCreation({
        license_key: getEightDigitLicenseKey(
          transferDetails.fflMasterDetails.licenseId
        ),
        isReinitiate: true
      })
    );
  }
  9;

  function clearEZStates() {
    dispatch(setEZCheckStatusTransferCreation(null));
    dispatch(setisTransferCreationAllowed(false));
    dispatch(setIsEzCheckHistoryInprogress(false));
    dispatch(setIsTransferReinitiateAllowed(false));
  }

  async function reInitiateTransferHandler() {
    setIsReinitiating(true);
    try {
      await reinitiateTransfer({ transferId: data?.id || '' });
    } catch (err) {
      console.log(err);
    } finally {
      setIsReinitiating(false);
      clearEZStates();
    }
  }

  useEffect(() => {
    if (isTransferReinitiateAllowed && !ezCheckForTransferCreationInProgress) {
      setTimeout(() => reInitiateTransferHandler(), 2000);
    }
  }, [isTransferReinitiateAllowed]);

  const navigateToArchive = () => {
    let params = {};
    const urlParams = new URLSearchParams(window.location.search);
    for(let [key, value] of urlParams.entries()) {
      params = {...params, [key]: value};
    }
    setURLSearchParams({...params, "archive": "true"})
  }

  const navigateToTransferQueue = () => {
    searchParams.delete("archive");
    searchParams.delete("transfer_id");
    setURLSearchParams(searchParams);
    dispatch(setTransferCurrentNavigation(TransferCurrentNavigation.TRANSFER_QUEUE));
  }

  useEffect(() => {
    if(isTransferForArchiveUpdated) {
      dispatch(setIsTransferForArchiveUpdated(false));
      refetchTranferQueue();
      OutlineToasterNotification(
        Toastertype.success,
        TRANSFER_ACTION_SUCCESSFULL.replace("{{ACTION}}", transferDetails.TransferDetails?.isArchive ? UN_ARCHIVED : ARCHIVED),
        transferDetails.TransferDetails?.isArchive ? navigateToTransferQueue : navigateToArchive,
        VIEW_THE_PAGE.replace("{{PAGE}}", transferDetails.TransferDetails?.isArchive ? TRANSFER_QUEUE : ARCHIVE_TEXT.toLowerCase())
      );
      handleClose();
    }
  }, [isTransferForArchiveUpdated])

  useEffect(() => {
    return () => clearEZStates();
  }, []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isFetchingTransferStatusWorkflow =
    getIsFetchingTransferStatusWorkflow();
  const transferStatusWorkflow = getTransferStatusWorkflow();
  const inboundTransferStatusWorkflow = getInboundTransferStatusWorkflow()
  const transferSuggestion = getTransferSuggestion();

  useEffect(() => {
    getTransferStatus();
  }, []);

  useEffect(() => {
    let isShowTransferProofLink = true;
    if (transferWorkflowStepperValue) {
      transferWorkflowStepperValue.some((transferStatus) => {
        if (transferStatus.stepStatus === transferStepStatus.failed) {
          isShowTransferProofLink = false;
          setHideRefreshBtn(true);
          return true;
        }
        if (
          (transferStatus.status ===
            TransferMacrostatus.outbound_transfer_complete || transferStatus.status ===
            INBOUND_TRANSFER_API_STATUES_RESPONSE.inbound_transfer_complete) &&
          transferStatus.stepStatus === transferStepStatus.success
        )
          {
            setHideRefreshBtn(true);
            return true;
          }
        else setHideRefreshBtn(false);
      });
    }
    setisDownloadTransferProofEnabled(isShowTransferProofLink);
  }, [transferStatusWorkflow, inboundTransferStatusWorkflow, isSuperAdmin]);

  // useEffect(() => {
  //   transferStatusWorkflow.forEach((transferStatus) => {
  //     if(transferStatus.status === TransferMacrostatus.outbound_transfer_confirmed && !transferDetails?.TransferDetails?.transfer_proof_link) refreshTransferDetails();
  //     if (
  //       transferStatus.stepStatus === transferStepStatus.failed ||
  //       (transferStatus.status ===
  //         TransferMacrostatus.outbound_transfer_complete &&
  //       transferStatus.stepStatus === transferStepStatus.success)
  //     )
  //       clearInterval(transferStatusInterval);
  //   });
  // }, [transferStatusWorkflow]);

  useEffect(() => {
    let isShowTransferProofLink = true;
    if (transferWorkflowStepperValue) {
      transferWorkflowStepperValue.forEach((transferStatus) => {
        if (transferStatus.stepStatus === transferStepStatus.failed || Object.keys(inboundTransferMacroStatus).includes(transferStatus.status))
          isShowTransferProofLink = false;
      });
    }
    setisDownloadTransferProofEnabled(isShowTransferProofLink);
  }, [transferStatusWorkflow, inboundTransferStatusWorkflow, isSuperAdmin]);

  if (!data) {
    return null;
  }

  function phoneNumbers(values: Array<string>) {
    return (
      String(
        values.map((ele: string) => {
          return formatPhoneNumber(ele);
        })
      ) || '-'
    );
  }

  function openFFLDetails() {
    const licenseNumber = transferDetails.fflMasterDetails.licenseId;
    setLicenseeId(licenseNumber);
    onOpen();
  }

  let suggestion = null;

  // const getStepperIndex = () => {
  //   let index = 0;
  //   let microStatusForSuggestion: Array<TransferMicroStatusWorkflow> = [];
  //   if (!transferStatusWorkflow || transferStatusWorkflow.length <= 0)
  //     return index;
  //   transferStatusWorkflow.map((step) => {
  //     const { stepStatus, order, microStatus } = step;
  //     if (
  //       stepStatus === transferStepStatus.success ||
  //       stepStatus === transferStepStatus.in_progress ||
  //       stepStatus === transferStepStatus.failed
  //     )
  //       if (order > index) {
  //         index = order > index ? order : index;
  //         microStatusForSuggestion = microStatus;
  //       }
  //   });
  //   if (microStatusForSuggestion && microStatusForSuggestion.length > 0)
  //     microStatusForSuggestion.forEach((microStep) => {
  //       if (transferTips[microStep.status as keyType<typeof transferTips>]) {
  //         suggestion =
  //           transferTips[microStep.status as keyType<typeof transferTips>];
  //       }
  //     });
  //   return index - 1;
  // };

  // const currentStep = getStepperIndex();


  const onClickRefreshBtn = () => {
    dispatch(setIsRefreshingTransferStatus(true));
    getTransferStatus();
    if (transferWorkflowStepperValue)
      transferWorkflowStepperValue.some((transferStatus) => {
        if (
          transferStatus &&
          transferStatus.status ===
            TransferMacrostatus.outbound_transfer_confirmed &&
          (transferStatus.stepStatus === transferStepStatus.in_progress ||
            transferStatus.stepStatus === transferStepStatus.success) &&
          !transferDetails?.TransferDetails?.transfer_proof_link
        ) {
          refreshTransferDetails();
          return true;
        }
      });
  };

  const onClickArchiveAction = (isArchive: boolean) => {
    return () => {
      dispatch(callToUpdateTransferArchive({isArchive, id: transferDetails?.TransferDetails.transferId}));
    }
  }

  const transferWorkflowStepperValue = useMemo(()=>{
    if (isSuperAdmin || transferStatusWorkflow?.length) return transferStatusWorkflow
    else return inboundTransferStatusWorkflow
  },[isSuperAdmin, transferStatusWorkflow, inboundTransferStatusWorkflow])

  const showActionButtons = useMemo(() => {
    let showActions = false;
    let buttonText = null;
    let apiActions = ""
    if (inboundTransferStatusWorkflow.length) {
      const statusReponse = inboundTransferStatusWorkflow.find(obj => (
        (obj.stepStatus === transferStepStatus.in_progress) &&
        (obj.status === INBOUND_TRANSFER_API_STATUES_RESPONSE.inbound_transfer_awaiting_item || obj.status === INBOUND_TRANSFER_API_STATUES_RESPONSE.inbound_transfer_item_received)
      ))
      if (statusReponse){
        showActions = true
        buttonText = INBOUND_TRANSFER_STATUS_CORRESPONDING_ACTION[statusReponse.status as keyType<typeof INBOUND_TRANSFER_STATUS_CORRESPONDING_ACTION>]
        apiActions = INBOUND_TRANSFER_ACTION[statusReponse.status as keyType<typeof INBOUND_TRANSFER_ACTION>]
      }
    }
    return { showActions, buttonText, apiActions }

  },[inboundTransferStatusWorkflow])

  const onClickTransferAction = (action: string) => {
    return () => {
      dispatch(callInBoundTransferAction({action, id: transferDetails?.TransferDetails.transferId}));
      onClickRefreshBtn()
    }
  }


  return (
    <div>
      <Box className="transfer-details">
        {isFetchingDetails && <Spinner className={'Spinner'} />}
        <FFLDetailModal
          id={licenseeId}
          isOpen={isOpen}
          onClose={onClose}
          cognitoGroup={cognitoGroup}
          isSuperAdmin={isSuperAdmin}
        />
        <div className="transfer-details-container">
          <div className="transfer-details">
            <div className="transfer-details__left">
              <ul className="transfer-details-left__info">
                <li>
                  <span className="transfer-details-label">
                    License Number:
                  </span>
                  <span className="transfer-details-value">
                    <a
                      onClick={openFFLDetails}
                      className="transfer-details__link"
                      href="#"
                    >
                      {transferDetails.fflMasterDetails.licenseId}
                    </a>
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">{BUSINESS_NAME}:</span>
                  <span className="transfer-details-value">
                    <a
                      className="transfer-details__link"
                      href="#"
                      onClick={openFFLDetails}
                    >
                      {transferDetails.fflMasterDetails?.businessName || '-'}
                    </a>
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">Contact Name:</span>
                  <span className="transfer-details-value">
                    {transferDetails.fflMasterDetails.contactName &&
                    transferDetails.fflMasterDetails.contactName.length > 0
                      ? String(transferDetails.fflMasterDetails.contactName[0])
                      : '-'}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">Buyer Name:</span>
                  <span className="transfer-details-value">
                    {transferDetails.TransferDetails.buyer.name || '-'}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label text-capitalize">{ TRANSFER_DETAILS.FIREARM_TYPE }:</span>
                  <span className="transfer-details-value">
                    {transferDetails.TransferDetails.products
                      ? getFormattedProduct(
                          transferDetails.TransferDetails.products[0]
                        )
                      : '-'}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">
                    Preferred Shipping Address:
                  </span>
                  <span className="transfer-details-value">
                    {transferDetails.TransferDetails?.shippingAddress ? (
                      <>
                        <div className="transfer-details-value">
                          {transferDetails.TransferDetails.shippingAddress.street}
                        </div>
                        <div className="transfer-details-value">
                        {transferDetails.TransferDetails.shippingAddress.city},{" "}{transferDetails.TransferDetails.shippingAddress.state}{" "}{transferDetails.TransferDetails.shippingAddress.zipCode}
                      </div>
                    </>
                    ) : (
                      '-'
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="transfer-details__right">
              <ul className="transfer-details-right__info">
                <li>
                  <span className="transfer-details-label">Business Type:</span>
                  <span className="transfer-details-value">
                    {transferDetails.fflMasterDetails.businessType || '-'}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">
                    Contact Number:
                  </span>
                  <span className="transfer-details-value">
                    {phoneNumbers(
                      transferDetails.fflMasterDetails.contactNumber
                    )}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">Used Email ID:</span>
                  <span className="transfer-details-value">
                    {transferDetails?.TransferDetails?.message?.usedEmail ||
                      '-'}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">Order ID:</span>
                  <span className="transfer-details-value">
                    {transferDetails.TransferDetails.orderId || '-'}
                  </span>
                </li>
                <li>
                  <span className="transfer-details-label">Notes:</span>
                  <span className="transfer-details-value transfer-details-value__scrollable">
                    {String(transferDetails?.TransferDetails.notes) || '-'}
                  </span>
                </li>
                {/* <li>
                <span className="transfer-details-label">Status:</span>
                <span className="transfer-details-value">
                  {' '}
                  <div className="transfer-details__dropdown">
                    {!isFetchingDetails && (
                      <>
                        <div className="transfer-details__dropdown-select">
                          <AriaSelect onSelectionChange={onchangeStatusDropdown} selectedKey={transferStatus}>
                        <AriaButton>
                          <SelectValue  />
                          <img src="images/ui/white-down-arrow.svg" />
                        </AriaButton>
                        <Popover>
                          <ListBox>
                            {Object.entries(transferMacrostatus).map(
                              ([key, value], index) => (
                                <ListBoxItem id={key}>
                                  {value}
                                </ListBoxItem>
                              )
                            )}
                          </ListBox>
                        </Popover>
                      </AriaSelect>
                          <AriaSelectDropdown
                          onChangeDropdown={onchangeStatusDropdown}
                          selectedOption={transferStatus}
                          options={Object.entries(transferMacrostatus)}
                        />
                          <span className="transfer-details-value">
                            {transferStatus
                              ? transferMacrostatus[transferStatus]
                              : '-'}
                          </span>
                        </div>
                        <DropDown
                          onOpen={onOpenStatusWorkFLow}
                          onClose={onCloseStatusWorkFLow}
                          isOpen={isStatusWorkFlowOpen}
                          popoverContent={
                            <>
                              {isFetchingTransferStatusWorkflow ? (
                                <Spinner size="sm" />
                              ) : (
                                <TransferWorkflowStatus
                                  transferStatusWorkflow={
                                    transferStatusWorkflow
                                  }
                                />
                              )}
                            </>
                          }
                          placement="bottom-end"
                          variant="transfer-status-workflow"
                        >
                          <button
                            className="transfer-details__workflow_status"
                            onClick={onClickHistoryIcon}
                          >
                            <Tooltip
                              hasArrow
                              placement="top"
                              label="Show Status History"
                              color={'black'}
                              bg={'white'}
                            >
                              <img src="/images/ui/history-outline.svg" />
                            </Tooltip>
                          </button>
                        </DropDown>
                      </>
                    )}
                  </div>
                  {(isSuperAdmin || isStoreAdmin) && !isFetchingDetails && (
                    <Button
                      className="reinitiate-btn"
                      isDisabled={
                        ezCheckForTransferCreationInProgress ||
                        Boolean(ezCheckStatus)
                      }
                      onClick={onClickReinitiate}
                      isLoading={
                        isReinitiating || ezCheckForTransferCreationInProgress
                      }
                      loadingText={
                        ezCheckForTransferCreationInProgress
                          ? 'Performiing EZ check'
                          : isReinitiating && 'Re-initiating Transfer'
                      }
                    >
                      {!ezCheckForTransferCreationInProgress &&
                        ezMessageMapping[
                          ezCheckStatus as keyType<typeof ezMessageMapping>
                        ]}
                      {!ezCheckForTransferCreationInProgress &&
                        !isReinitiating &&
                        !ezCheckStatus &&
                        'Re-initiate Transfer'}
                    </Button>
                  )}
                </span>
              </li> */}
              </ul>
            </div>
          </div>
          {/* <div className="note-container">
          <span className="transfer-details-label">Notes:</span>
          <span className="transfer-details-value note-section">
            {String(data?.notes) || '-'}
          </span>
        </div> */}
          {transferWorkflowStepperValue && (
            <TransferStatusStepper 
              transferStatusWorkflow={transferWorkflowStepperValue}
              version={transferDetails?.TransferDetails?.version ? transferDetails?.TransferDetails?.version : 2}
             />
          )}
        </div>
      </Box>
      <div className="transfer-details-footer">
        {suggestion && (
          <div className="transfer-details__tips">
            <img src="images/ui/tips.svg" alt="" style={{ width: '14.58px' }} />
            {suggestion}
          </div>
        )}
        {transferDetails?.TransferDetails?.transfer_proof_link &&
          isDownloadTransferProofEnabled && (
            <a
              href={transferDetails.TransferDetails.transfer_proof_link}
              className="transfer-details__download-action"
            >
              {DOWNLOAD_MASTER_PROOF_TEXT}
            </a>
          )}
          {
            !isFetchingDetails && isStoreAdmin && <Button className='transfer-details__archive-btn' onClick={onClickArchiveAction(!transferDetails.TransferDetails?.isArchive)} loadingText={transferDetails.TransferDetails?.isArchive ? UN_ARCHIVE_TEXT : ARCHIVE_TEXT} isLoading={isUpdatingTransferForArchive}><img src='/images/ui/archive-icon.svg' />{transferDetails.TransferDetails?.isArchive ? UN_ARCHIVE_TEXT : ARCHIVE_TEXT }</Button>
          }
          {
            showActionButtons.showActions && <Button className='transfer-details__archive-btn' onClick={onClickTransferAction(showActionButtons.apiActions)}>{showActionButtons.buttonText}</Button>
          }
        </div>
      {!hideRefreshBtn && (
        <div className="transfer-details__refresh-btn">
          <Tooltip
            hasArrow
            placement="top"
            label="Refresh"
            color={'black'}
            bg={'white'}
          >
            <Button
              isLoading={isRefreshingTransferStatus}
              spinner={
                <img
                  className="refresh-btn__spinner"
                  src="/images/ui/refresh.svg"
                />
              }
              className="refresh-btn"
              onClick={onClickRefreshBtn}
            >
              <img src="/images/ui/refresh.svg" />
            </Button>
          </Tooltip>
        </div>
      )}
    </div>
  );
}
